import createIcon from '../../createIcon';

/**
 * @component @name Loyalty
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuNDEgMTEuNThMMTIuNDEgMi41OEMxMi4wNSAyLjIyIDExLjU1IDIgMTEgMkg0QzIuOSAyIDIgMi45IDIgNFYxMUMyIDExLjU1IDIuMjIgMTIuMDUgMi41OSAxMi40MkwxMS41OSAyMS40MkMxMS45NSAyMS43OCAxMi40NSAyMiAxMyAyMkMxMy41NSAyMiAxNC4wNSAyMS43OCAxNC40MSAyMS40MUwyMS40MSAxNC40MUMyMS43OCAxNC4wNSAyMiAxMy41NSAyMiAxM0MyMiAxMi40NSAyMS43NyAxMS45NCAyMS40MSAxMS41OFpNNS41IDdDNC42NyA3IDQgNi4zMyA0IDUuNUM0IDQuNjcgNC42NyA0IDUuNSA0QzYuMzMgNCA3IDQuNjcgNyA1LjVDNyA2LjMzIDYuMzMgNyA1LjUgN1pNMTcuMjcgMTUuMjdMMTMgMTkuNTRMOC43MyAxNS4yN0M4LjI4IDE0LjgxIDggMTQuMTkgOCAxMy41QzggMTIuMTIgOS4xMiAxMSAxMC41IDExQzExLjE5IDExIDExLjgyIDExLjI4IDEyLjI3IDExLjc0TDEzIDEyLjQ2TDEzLjczIDExLjczQzE0LjE4IDExLjI4IDE0LjgxIDExIDE1LjUgMTFDMTYuODggMTEgMTggMTIuMTIgMTggMTMuNUMxOCAxNC4xOSAxNy43MiAxNC44MiAxNy4yNyAxNS4yN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Loyalty = createIcon('Loyalty', [
  [
    'path',
    {
      d: 'M21.41 11.58L12.41 2.58C12.05 2.22 11.55 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.55 2.22 12.05 2.59 12.42L11.59 21.42C11.95 21.78 12.45 22 13 22C13.55 22 14.05 21.78 14.41 21.41L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.45 21.77 11.94 21.41 11.58ZM5.5 7C4.67 7 4 6.33 4 5.5C4 4.67 4.67 4 5.5 4C6.33 4 7 4.67 7 5.5C7 6.33 6.33 7 5.5 7ZM17.27 15.27L13 19.54L8.73 15.27C8.28 14.81 8 14.19 8 13.5C8 12.12 9.12 11 10.5 11C11.19 11 11.82 11.28 12.27 11.74L13 12.46L13.73 11.73C14.18 11.28 14.81 11 15.5 11C16.88 11 18 12.12 18 13.5C18 14.19 17.72 14.82 17.27 15.27Z',
      key: '1lm7ab',
    },
  ],
]);

export default Loyalty;
